import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

const MenuGroup = ({
  children,
  className = "",
  style,
  title,
}: {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}) => (
  <DropdownMenuPrimitive.Group
    className={`dropdown-menu-group ${className}`}
    style={style}
  >
    {title && (
      <DropdownMenuPrimitive.Label className="dropdown-menu-group-title">
        {title}
      </DropdownMenuPrimitive.Label>
    )}
    {children}
  </DropdownMenuPrimitive.Group>
);

export default MenuGroup;
MenuGroup.displayName = "DropdownMenuGroup";
